import { DealOverview } from "@components/DealOverview";
import { DealLayout } from "@components/layouts/DealLayout";
import React from "react";

export const DealPage = () => (
	<DealLayout>
		<DealOverview />
	</DealLayout>
);
